"use strict";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InputStyles = exports.StyledOverflow = exports.StyledSelectBox = exports.StyledContainer = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var StyledContainer = _styledComponents["default"].div.withConfig({
  displayName: "style__StyledContainer",
  componentId: "sc-1iw6b7w-0"
})(["margin:10px;", ""], function (props) {
  return (props.isCompact || props.forceCompact) && (0, _styledComponents.css)(["display:flex;align-items:center;"]);
});

exports.StyledContainer = StyledContainer;

var StyledSelectBox = _styledComponents["default"].div.withConfig({
  displayName: "style__StyledSelectBox",
  componentId: "sc-1iw6b7w-1"
})(["", ""], function (props) {
  return (props.isCompact || props.forceCompact) && (0, _styledComponents.css)(["width:100%;padding-right:15px;"]);
});

exports.StyledSelectBox = StyledSelectBox;

var StyledOverflow = _styledComponents["default"].div.withConfig({
  displayName: "style__StyledOverflow",
  componentId: "sc-1iw6b7w-2"
})(["position:absolute;width:100%;height:100%;top:0;left:0;background-color:rgba(0,0,0,0.1);z-index:10;"]);

exports.StyledOverflow = StyledOverflow;
var InputStyles = {
  container: function container() {
    return {
      position: "relative",
      boxSizing: "border-box",
      cursor: "pointer",
      border: "1px solid rgba(202,204,208,0.85)",
      borderRadius: "4px",
      backgroundColor: "rgba(255,255,255,1)"
    };
  },
  indicatorSeparator: function indicatorSeparator() {
    return {
      display: "none"
    };
  },
  dropdownIndicator: function dropdownIndicator(provided, state) {
    return {
      color: "#c32d7b",
      transition: "all 0.2s ease-out"
    };
  },
  indicatorsContainer: function indicatorsContainer() {
    return {
      color: "#c32d7b",
      display: "flex",
      padding: "8px",
      transition: "color 150ms",
      boxSizing: "border-box",
      position: "relative",
      top: "5px"
    };
  },
  control: function control() {
    return {
      display: "flex",
      border: "none",
      borderRadius: "4px",
      padding: "3px 0"
    };
  }
};
exports.InputStyles = InputStyles;